const PHRASES = [
  "Paid per video",
  "Fully remote",
  "$55+ Standard · $110+ HQ animation",
  "$20 / completed edit",
  "$10 / accepted script",
  "No fixed schedule",
  "Your work, real audience",
  "Creative freedom",
];

export const EditorialMarquee = () => {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-slate-900/10 bg-slate-950 py-5">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">{p}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-cyan-400" aria-hidden="true" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
